import styled from "@emotion/styled";

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
`;
